module.exports = __webpack_public_path__ + "img/2_13.a75ed7e4.jpg";